export const RTF_CONFIGURATION_MANAGEMENT_LOGS_DATA_FETCH = 'RTF_CONFIGURATION_MANAGEMENT_LOGS_DATA_FETCH'
export const DEFAULT_LOGS_PAGE_SIZE = 10

export type GetConfigManagementLogsFunction = (filter?: ConfigManagementUploadLogFilter, page?: number, pageSize?: number) => void
export type ClearConfigManagementLogsFunction = () => void

export type ConfigManagementLogsState = {
  items: Array<ConfigManagementLog>
  totalElements: number
  filter: ConfigManagementUploadLogFilter
  page: number
  pageSize: number
}

export enum ConfigManagementLogActions {
  setList = 'setLogList',
  clearList = 'clearLogList',
}

export type ConfigManagementLogPayload = {
  type: ConfigManagementLogActions.setList
  payload: ConfigManagementLogsState
} | {
  type: ConfigManagementLogActions.clearList
  payload: undefined
} 

export type ConfigManagementLog = {
  resourceName: string
  operation: string
  status: string
  createdDate: string
  createdBy: string
}

export type AxiosConfigManagementLogResponse = {
  data: {
    items: Array<ConfigManagementLog>
    totalElements: string
  }
}

export enum ConfigManagementLogOperation {
  upload = 'UPLOAD',
  delete = 'DELETE',
}

export enum ConfigManagementLogStatus {
  success = 'SUCCESS',
  failed = 'FAILED',
}

export type ConfigManagementUploadLogFilter = {
  resourceName?: string
  status?: string
  operation?: string
  createdBy?: string
  createdDateFrom?: string
  createdDateTo?: string
}
